import { render, staticRenderFns } from "./Locale.vue?vue&type=template&id=16c48ff9&"
import script from "./Locale.vue?vue&type=script&lang=js&"
export * from "./Locale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c48ff9')) {
      api.createRecord('16c48ff9', component.options)
    } else {
      api.reload('16c48ff9', component.options)
    }
    module.hot.accept("./Locale.vue?vue&type=template&id=16c48ff9&", function () {
      api.rerender('16c48ff9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/components/Locale.vue"
export default component.exports